import React, { useMemo } from 'react'
import IconWrapper from '../Cards/IconWrapper';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { scrollToTop } from '../../utility/scrollUtilities';

function Pagination({currentPage, pageLimit , totalItems ,setCurrentPage}) {
  const numberOfPages = Math.ceil(totalItems/pageLimit);
  const visiblePages = 4;

  const resultValue = useMemo(()=>
    (currentPage === numberOfPages ? totalItems - ((currentPage-1) * pageLimit) : pageLimit)
  ,[pageLimit,currentPage,numberOfPages,totalItems])

  const getVisibilePageNumbers = useMemo(()=>{
    let pages = Array.from({length : numberOfPages}).map((_,i)=>i + 1);
    if(numberOfPages > visiblePages && (numberOfPages - currentPage) >= visiblePages - 1){
      if(currentPage > visiblePages){
        return pages.slice(currentPage - visiblePages,currentPage)
      }
      return pages.slice(0, visiblePages)
    }else if(numberOfPages > visiblePages && (numberOfPages - currentPage) < visiblePages - 1){
      return pages.slice(-visiblePages)
    }
    return pages
  },[numberOfPages,currentPage])

  const handlePrev = () => {
    scrollToTop()
    setCurrentPage(prev => prev - 1)
  }
  
  const handleNext = () => {
    scrollToTop()
    setCurrentPage(prev => prev + 1)
  }
  
  const handleItemClick = (item) => {
    scrollToTop()
    setCurrentPage(item)
  }
  

  return totalItems ? (
    <div className=' flex justify-between'>
      <div>
      <p className='typography-body text-font-gray flex gap-2'>Showing <span className='text-font-main'>{resultValue}</span><span className='hidden sm:inline-block'> {resultValue > 1 ? " results" : " result"}</span> of <span className='text-font-main'>{totalItems}</span></p>
      </div>
      <div className='flex items-center gap-4'>
          <div onClick={currentPage > 1 ? handlePrev : null} className={currentPage > 1 ? "text-font-main cursor-pointer" : "text-font-gray"}>
            <IconWrapper inheritColor icon={ChevronLeft} size={0} customIconSize={5} customStrokeWidth={5} />
          </div>
            {
              getVisibilePageNumbers?.map(item =>{
                return <p key={item} onClick={() => handleItemClick(item)} className={currentPage === item ? "text-font-main cursor-pointer" : "text-font-gray cursor-pointer"}>{item}</p>
              })
            }
          <div onClick={currentPage !== numberOfPages ? handleNext : null} className={currentPage === numberOfPages ? "text-font-gray" : "text-font-main cursor-pointer"}>
            <IconWrapper inheritColor icon={ChevronRight} size={0} customIconSize={5} customStrokeWidth={5} />
          </div>
      </div>
    </div>
  ) : null
}

export default Pagination
